import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const ParentService = {}


ParentService.getParent = function (params) {
	let {page, searchParent} = params;
	let offset = (page-1)*10;
	 
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-parent',
		method: 'get',
        params: {
            'offset' : offset,
			searchParent
        }
	})
}; 

ParentService.getParentWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-parent/${id}`,
		method: 'get',

	})
};

ParentService.getParentPlayer = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/parent-player/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};


export default ParentService;